<p-accordion [activeIndex]="activeTab()" (onOpen)="onAccordionChange($event.index)">
  <p-accordionTab>
    <ng-template pTemplate="header">
      <div class="flex w-full justify-content-between">
        <span
          [ngStyle]="{
            'font-weight': ticket.relatedTicketCounts.customerNameCount > 0 ? 'bold' : 'normal',
            color: ticket.relatedTicketCounts.customerNameCount > 0 ? 'black' : ''
          }"
          pTooltip="{{ ticket.relatedTicketCounts.customerNameCount }}"
          tooltipPosition="top"
        >
          Customer
        </span>
        <p-badge [value]="ticket.relatedTicketCounts.customerNameCount"></p-badge>
      </div>
    </ng-template>
    @if (tickets?.length) {
      <p-table [value]="tickets" [rows]="5" [paginator]="true" [autoLayout]="true">
        <ng-template pTemplate="body" let-ticket>
          <tr>
            <td>
              <a routerLink="/tickets/{{ ticket.id }}" target="_blank"
                 class="flex justify-content-between align-items-center">
                <span># {{ ticket.id + ' ' + ticket.customer.name }}</span>
                <tj-ticket-status [status]="ticket.status"></tj-ticket-status>
              </a>
            </td>
          </tr>
        </ng-template>
      </p-table>
    } @else {
      <span class="w-full text-center">No Match</span>
    }
  </p-accordionTab>

  <p-accordionTab>
    <ng-template pTemplate="header">
      <div class="flex w-full justify-content-between">
        <span
          [ngStyle]="{
            'font-weight': ticket.relatedTicketCounts.addressCount > 0 ? 'bold' : 'normal',
            color: ticket.relatedTicketCounts.addressCount > 0 ? 'black' : ''
          }"
          pTooltip="{{ ticket.relatedTicketCounts.addressCount }}"
          tooltipPosition="top"
        >
          Addr.
        </span>
        <p-badge [value]="ticket.relatedTicketCounts.addressCount"></p-badge>
      </div>
    </ng-template>
    @if (tickets?.length) {
      <p-table [value]="tickets" [rows]="5" [paginator]="true" [autoLayout]="true">
        <ng-template pTemplate="body" let-ticket>
          <tr>
            <td>
              <a routerLink="/tickets/{{ ticket.id }}" target="_blank"
                 class="flex justify-content-between align-items-center">
                <span># {{ ticket.id + ' ' + ticket.customer.name }}</span>
                <tj-ticket-status [status]="ticket.status"></tj-ticket-status>
              </a>
            </td>
          </tr>
        </ng-template>
      </p-table>
    } @else {
      <span class="w-full text-center">No Match</span>
    }
  </p-accordionTab>

  <p-accordionTab>
    <ng-template pTemplate="header">
      <div class="flex w-full justify-content-between">
        <span
          [ngStyle]="{
            'font-weight': ticket.relatedTicketCounts.customerContactsCount > 0 ? 'bold' : 'normal',
            color: ticket.relatedTicketCounts.customerContactsCount > 0 ? 'black' : ''
          }"
          pTooltip="{{ ticket.relatedTicketCounts.customerContactsCount }}"
          tooltipPosition="top"
        >
          Phone / Email
        </span>
        <p-badge [value]="ticket.relatedTicketCounts.customerContactsCount"></p-badge>
      </div>
    </ng-template>
    @if (tickets?.length) {
      <p-table [value]="tickets" [rows]="5" [paginator]="true" [autoLayout]="true">
        <ng-template pTemplate="body" let-ticket>
          <tr>
            <td>
              <a routerLink="/tickets/{{ ticket.id }}" target="_blank"
                 class="flex justify-content-between align-items-center">
                <span># {{ ticket.id + ' ' + ticket.customer.name }}</span>
                <tj-ticket-status [status]="ticket.status"></tj-ticket-status>
              </a>
            </td>
          </tr>
        </ng-template>
      </p-table>
    } @else {
      <span class="w-full text-center">No Match</span>
    }
  </p-accordionTab>

  <p-accordionTab>
    <ng-template pTemplate="header">
      <div class="flex w-full justify-content-between">
        <span
          [ngStyle]="{
            'font-weight': ticket.relatedTicketCounts.workOrderCount > 0 ? 'bold' : 'normal',
            color: ticket.relatedTicketCounts.workOrderCount > 0 ? 'black' : ''
          }"
          pTooltip="{{ ticket.relatedTicketCounts.workOrderCount }}"
          tooltipPosition="top"
        >
          PO/WO/SALES
        </span>
        <p-badge [value]="ticket.relatedTicketCounts.workOrderCount"></p-badge>
      </div>
    </ng-template>
    @if (tickets?.length) {
      <p-table [value]="tickets" [rows]="5" [paginator]="true" [autoLayout]="true">
        <ng-template pTemplate="body" let-ticket>
          <tr>
            <td>
              <a routerLink="/tickets/{{ ticket.id }}" target="_blank"
                 class="flex justify-content-between align-items-center">
                <span># {{ ticket.id + ' ' + ticket.customer.name }}</span>
                <tj-ticket-status [status]="ticket.status"></tj-ticket-status>
              </a>
            </td>
          </tr>
        </ng-template>
      </p-table>
    } @else {
      <span class="w-full text-center">No Match</span>
    }
  </p-accordionTab>
</p-accordion>
<div *ngIf="isLoading" class="overlay text-center py-4">
  <p-progressSpinner styleClass="custom-spinner-related w-4rem h-4rem" strokeWidth="3"></p-progressSpinner>
</div>
